import { render, staticRenderFns } from "./report-view.vue?vue&type=template&id=779f3b84&scoped=true"
import script from "./report-view.vue?vue&type=script&lang=js"
export * from "./report-view.vue?vue&type=script&lang=js"
import style0 from "./report-view.vue?vue&type=style&index=0&id=779f3b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f3b84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReportBusinessOverall: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-business-overall.vue').default,ReportChannelOrderTable: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-channel-order-table.vue').default,ReportOrdersCount: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-orders-count.vue').default,ReportItemSales: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-item-sales.vue').default,ReportChannelComparison: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-channel-comparison.vue').default,ReportStoreAvailability: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-store-availability.vue').default,ReportOrderAcknowledgementStagesDurationTabs: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-order-acknowledgement-stages-duration-tabs.vue').default,ReportBusinessInsights: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-business-insights.vue').default,ReportPeakHours: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-peak-hours.vue').default,ReportDeliveredLocation: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-delivered-location.vue').default})
